import React from 'react'
import styled from 'styled-components'

interface RichTextContentProps {
  content: string
  className?: string
  style?: React.CSSProperties
}

const RichTextContent: React.FC<RichTextContentProps> = ({content, className, style}) => {
  return <StyledRichTextContent className={`rich-text-content ${className || ''}`} style={style} dangerouslySetInnerHTML={{__html: content || ''}} />
}

const StyledRichTextContent = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;

  & a {
    color: #0e78f5;
    text-decoration: underline;
  }

  & ul,
  & ol {
    padding-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  & h1 {
    font-size: 22px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  & h2 {
    font-size: 20px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 8px;
  }

  & h3 {
    font-size: 18px;
    font-weight: 500;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  & p {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  & blockquote {
    border-left: 3px solid #ccc;
    padding-left: 10px;
    margin-left: 10px;
    font-style: italic;
    color: #555;
  }

  & img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }

  & *:first-child {
    margin-top: 0;
  }

  & *:last-child {
    margin-bottom: 0;
  }
`

export default RichTextContent
